module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "website",
    class: {
      'is-portrait': _vm.portrait
    }
  }, [_c('video', {
    staticClass: "website__video",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('source', {
      attrs: {
        "src": source
      }
    })
  })), _vm._v(" "), (!_vm.portrait) ? _c('span', {
    staticClass: "website__bar"
  }, [_c('span', {
    staticClass: "website__button"
  }), _vm._v(" "), _c('span', {
    staticClass: "website__button"
  }), _vm._v(" "), _c('span', {
    staticClass: "website__button"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b55446f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebsiteVideo.vue
// module id = 389
// module chunks = 2